/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * ShopifyAvailableFieldDtoBase
 * auto generated base class for the model ShopifyAvailableFieldDtoModel.
 */
export const ShopifyAvailableFieldDtoModelBase = ModelBase
  .named('ShopifyAvailableFieldDto')
  .props({
    __typename: types.optional(types.literal("ShopifyAvailableFieldDto"), "ShopifyAvailableFieldDto"),
    category: types.union(types.undefined, types.string),
    path: types.union(types.undefined, types.string),
    label: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class ShopifyAvailableFieldDtoModelSelector extends QueryBuilder {
  get category() { return this.__attr(`category`) }
  get path() { return this.__attr(`path`) }
  get label() { return this.__attr(`label`) }
}
export function selectFromShopifyAvailableFieldDto() {
  return new ShopifyAvailableFieldDtoModelSelector()
}

export const shopifyAvailableFieldDtoModelPrimitives = selectFromShopifyAvailableFieldDto().category.path.label
